import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { uidFactory } from '@10000/common'
import { useDelayedValue } from '@10000/react'
import { Box, Button, Close } from '../'
import './Dialog.scss'

const next = uidFactory(3000)

export const Dialog = ({ open, onClose, showControls = true, closeButton = true, mobileBackground = 'black', mobileDrawer = true, className, children, ...props }) => {
  const [zIndex, setZIndex] = useState()
  const visible = useDelayedValue(open, { false: 500 })

  // this is a hack to ensure the most recently opened dialog is on top
  useEffect(() => {
    if(open) {
      setZIndex(next())
    }
  }, [open])

  return createPortal(
    <Box
      className={`dialog-container${className ? ` ${className}` : ''}`}
      onClick={onClose}
      zIndex={visible ? zIndex : -1}
    >
      <Box
        className="dialog-overlay"
        opacity={open ? 1 : 0}
        cursor={onClose ? 'pointer' : 'default'}
      />
      <Box
        className={`dialog ${mobileBackground}${open ? ' slide-in' : ' slide-out'}${mobileDrawer ? ' mobile-drawer' : ''}`}
        column
        onClick={(event) => event.stopPropagation()}
        {...props}
      >
        {closeButton &&
          <Box
            className="close-button"
            position="absolute"
            top={0}
            right={0}
            p={16}
            cursor="pointer"
            onClick={onClose}
          >
            <Close fill="black" />
          </Box>
        }
        {children}
        {showControls &&
          <Button
            fullWidth
            onClick={e => {
              e.stopPropagation()
              onClose(e)
            }}
          >
            Done
          </Button>
        }
      </Box>
    </Box>,
    document.body
  )
}
